import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import { type Root } from 'react-dom/client';

export default class WorkplaceApprovalsIndexController extends Controller {
  @service declare reactRenderer: ReactRendererService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { Approvals } = await import('reactRichComponents/workplace/Approvals');

    this.root = await this.reactRenderer.render(Approvals, 'react__workplace__approvals');
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
